/**
 * ferramentas.ts — Tabela SUS e uso de tokens (F11).
 *
 * Ferramentas do super admin que não pertencem a um domínio de negócio.
 */

import type { components } from './generated/api'
import { api } from './http'

export type TabelaSUS = components['schemas']['TabelaSUS']
export type UsoDeTokens = components['schemas']['UsoDeTokens']

export function estatisticasTabelaSUS() {
  return api<TabelaSUS>('/api/v1/ferramentas/tabela-sus')
}

export function enviarPlanilhaTabelaSUS(arquivo: File) {
  const form = new FormData()
  form.append('planilha', arquivo)
  return api<{
    atualizados: number
    inseridos: number
    falhas: number
    total: number
  }>('/api/v1/ferramentas/tabela-sus/planilha', { method: 'POST', form })
}

export function coletarTabelaSUS() {
  return api<{ task_id: string }>('/api/v1/ferramentas/tabela-sus/coleta', {
    method: 'POST',
  })
}

export function usoDeTokens(inicio: string, fim: string) {
  const parametros = new URLSearchParams()
  if (inicio) parametros.set('inicio', inicio)
  if (fim) parametros.set('fim', fim)
  return api<UsoDeTokens>(
    `/api/v1/ferramentas/tokens?${parametros.toString()}`,
  )
}
